import { render, staticRenderFns } from "./qschool.vue?vue&type=template&id=3e7aaeef&scoped=true"
import script from "./qschool.vue?vue&type=script&lang=js"
export * from "./qschool.vue?vue&type=script&lang=js"
import style0 from "./qschool.vue?vue&type=style&index=0&id=3e7aaeef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7aaeef",
  null
  
)

export default component.exports